module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhand8-fb953dbafa0936c8677ab3e59973cdbe.jpg";